
const digest = 'ab5b6315e4e519b6d57e899cd2fbcc20d91e839bd74267ed758c47b7c97f2d12';
const classes = {"wrapper":"_wrapper_1a898_1","options":"_options_1a898_8","seenWrapper":"_seenWrapper_1a898_17"};
const css = `._wrapper_1a898_1 {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  font-family: "Rubik", sans-serif;
}
._wrapper_1a898_1 ._options_1a898_8 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
  padding: 16px 24px;
  border: 1px solid #eaedf3;
  border-top: 0;
}
._wrapper_1a898_1 ._options_1a898_8 ._seenWrapper_1a898_17 {
  display: flex;
  gap: 5px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  